<mat-nav-list>
  <a
    mat-list-item
    [routerLink]="['/home']"
    routerLinkActive="router-link-active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-icon mat-list-icon>home</mat-icon>
      <span class="first-level">Home</span>
    </div>
  </a>
  <a
    mat-list-item
    [routerLink]="['/teams']"
    routerLinkActive="router-link-active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-icon mat-list-icon>people</mat-icon>
      <span class="first-level">Teams</span>
    </div>
  </a>
  <a
    mat-list-item
    [routerLink]="['/people']"
    routerLinkActive="router-link-active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-icon mat-list-icon>person</mat-icon>
      <span class="first-level">People</span>
    </div>
  </a>
  <a
    mat-list-item
    [routerLink]="['/reports']"
    routerLinkActive="router-link-active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-icon mat-list-icon>summarize</mat-icon>
      <span class="first-level">Reports</span>
    </div>
  </a>
  <a
    mat-list-item
    *ngIf="isAdmin()"
    [routerLink]="['/admin']"
    routerLinkActive="router-link-active"
    [routerLinkActiveOptions]="{ exact: true }"
  >
    <div fxLayout="row" fxLayoutAlign="start center">
      <mat-icon mat-list-icon>settings</mat-icon>
      <span class="first-level">Admin</span>
    </div>
  </a>
</mat-nav-list>
<mat-divider></mat-divider>
<mat-nav-list>
  <button tabindex="0" mat-list-item (click)="openWidget()">Support</button>
  <a mat-list-item href="https://www.lineupteams.com/privacy-policy" target="_blank" [attr.title]="'Privacy Policy'">
    Privacy Policy
  </a>
  <a
    mat-list-item
    href="https://support.lineupteams.com/hc/en-us/sections/360006008474-Release-Notes"
    target="_blank"
    [attr.title]="'Release Notes'"
  >
    Release Notes
  </a>
</mat-nav-list>
